import { render } from "./appointmentsDetail.vue?vue&type=template&id=6d247ef7"
import script from "./appointmentsDetail.vue?vue&type=script&lang=js"
export * from "./appointmentsDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__